<div class="text-center">
<h3 style="color: red;">Under Development</h3>
</div>
<div class="container mt-4">
    <div class="text-center">
        <h2>Apply Load/Unload Numbers</h2>
    </div>
    <div class="text-center headermsg">If Load Numbers</div>
    <div class="table-responsive">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th>Load #</th>
                    <th>Commodity</th>
                    <th>Contract #</th>
                    <th>Origin</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="text-center headermsg">If Unload Numbers</div>
    <div class="table-responsive">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th>Load #</th>
                    <th>Commodity</th>
                    <th>Contract #</th>
                    <th>Destination</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="row justify-content-center mt-4">
        <div class="col-md-4 col-6">
            <button mat-raised-button extended color="primary" type="button" class="w-100">
                Apply
            </button>
        </div>
        <div class="col-md-4 col-6">
            <button mat-raised-button extended color="primary" type="button" class="w-100" (click)="Cancel()">
                Cancel
            </button>
        </div>
    </div>
</div>
<app-footer-mobile></app-footer-mobile>
